import * as React from 'react';
import { ComponentProps, ButtonPrimary } from 'ui';
import { OpenStateInjectedProps } from 'ui/common/enhancers';
import { PrimaryActionComponentProps } from 'app/area/case-report/case-listing/types';
import { EmbeddedFavouriteButton } from '../embedded-favourite-button';
import * as navigate from 'app/area/shared/navigation';
import { serializeConnectionState } from 'app/area/case/draft/connected-state';

interface ConnectToBowtieButtonProps extends ComponentProps, OpenStateInjectedProps {
  readOnly?: boolean;
  entityId: number;
  textMissingSearchArguments: string;
  textOpenBowtie: string;
  textSearchTitle: string;
  requiredSearchFieldsFilled: boolean;
  createSearchForCasesToConnect: (draftId: number) => Promise<number>;
  favouriteComponent: React.ComponentType<any>;
}

export class ConnectToBowtieButton extends React.Component<ConnectToBowtieButtonProps> {

  private createFavourite = (): Promise<number> => {
    const { createSearchForCasesToConnect, entityId: draftId } = this.props;
    return createSearchForCasesToConnect(draftId);
  };

  private renderActionComponent = (props: PrimaryActionComponentProps) => {
    const openBowtie = () => {
      const { entityId: draftId } = this.props;
      const state = serializeConnectionState([
        { draftId }
      ]);
      navigate.toBowtieConnection(props.caseId, state);
    };
    return props.permissions && props.permissions.bowtie ?
      <ButtonPrimary onClick={openBowtie}>{this.props.textOpenBowtie}</ButtonPrimary> :
      null;
  };

  public render() {
    return <EmbeddedFavouriteButton
              {...this.props}
              renderActionComponent={this.renderActionComponent}
              createFavourite={this.createFavourite}
              />;
  }
}
